import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import {
    ImportManagement
} from "../../../../Component/Model/Dto/VerificationAgency/Client/ImportManagement/ImportManagement";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { TableDateTimeHelper } from "../../../../Component/Model/helpers";

interface ImportManagementHistoryTableRow {
    id: number;
    scorecardName: string;
    createdBy: string;
    createdDate: string | undefined;
    status: string;
    inProgress: number;
    completed: number;
    failed: number;
    actions: ActionType[];
}

export interface IImportManagementTable {
    columns: Array<TableColumn>;
    rows: Array<ImportManagementHistoryTableRow>;
}

export function ImportManagementHistoryTableMapper(results: ImportManagement.ImportManagementSearchResult[], onViewImportDetails: (id: string, isInProgress: string, scorecardId?: string) => void): IImportManagementTable {
    const columns = [
        { Header: 'Scorecard Name', accessor: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip maxWidth="130px" /> },
        { Header: 'User', accessor: 'createdBy', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Created Date', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Status', accessor: 'status', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'In Progress', accessor: 'inProgress', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Completed', accessor: 'completed', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Failed', accessor: 'failed', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (results.length >= 0) {
        const rows: ImportManagementHistoryTableRow[] = results.map((item: ImportManagement.ImportManagementSearchResult, index: number) => (
            {
                id: item.id,
                scorecardName: item.scorecardName,
                createdBy: item.createdBy,
                createdDate: TableDateTimeHelper(item.createdDate.toString()),
                status: item.status,
                inProgress: item.inProgress,
                completed: item.completed,
                failed: item.failed,
                actions: [
                    {
                        key: index.toString(),
                        label: 'View Import Details',
                        action: () => {
                            onViewImportDetails(item.id.toString(), (item.inProgress > 0 ? "true" : "false"), item.scorecardId);
                        },
                        icon: {
                            color: 'info',
                            name: 'visibility'
                        }
                    },
                ]
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}